import { requestV1 } from './base'
import {
  Post,
  CreatePostResponse,
  UpdatePostResponse
} from 'apis/response_types'

export const deletePost = (post_id: string) => {
  return requestV1<void>('delete', `/posts/${post_id}`)
}

export const createPost = (
  door_id: string,
  body: {
    title: string
    content: string
    room_id: number
    images?: Array<string>
    video?: string
    audios?: Array<string>
    documents?: Array<string>
    files?: Array<string>
    is_draft?: boolean
    scheduled_at?: string | null
  }
) => {
  return requestV1<CreatePostResponse>('post', `/doors/${door_id}/posts`, body)
}

export const updatePost = (
  post_id: string,
  body: {
    title?: string
    content?: string
    room_id: number
    images?: Array<string> // 新規画像追加用
    video?: string // undefined: 削除, string: 維持 or 新規ファイル
    audios?: Array<string>
    documents?: Array<string>
    files?: Array<string>
    delete_file_ids?: Array<number>
    delete_video_ids?: Array<number>
    publish?: boolean
    uploaded?: boolean
    is_draft?: boolean
    scheduled_at?: string | null
  }
) => {
  return requestV1<UpdatePostResponse>('patch', `/posts/${post_id}`, body)
}

export const searchContents = async (
  door_id: string,
  tab: 'post' | 'comment' | 'hashtag',
  keyword: string | '',
  per: number,
  page: number
) => {
  let url = `/doors/${door_id}/search`
  let queries: string[] = [
    `per=${per}`,
    `page=${page}`,
    `tab=${tab}`,
    `keyword=${encodeURI(keyword)}`
  ]
  if (queries.length) {
    url = url + '?' + queries.join('&')
  }
  return await requestV1<any>('get', url)
}

export const redirectPost = (post_id: string) => {
  return requestV1<{ url: string }>('get', `/posts/${post_id}/redirect`)
}

export const getPost = (post_id: string) => {
  return requestV1<Post>('get', `/posts/${post_id}`)
}
export const pinPostToHome = async (post_id: string) => {
  return await requestV1<null>('post', `/posts/${post_id}/pins/pinned_to_home`)
}

export const unpinPostToHome = async (post_id: string) => {
  return await requestV1<null>(
    'delete',
    `/posts/${post_id}/pins/pinned_to_home`
  )
}

export const pinPostToRoom = async (post_id: string) => {
  return await requestV1<null>('post', `/posts/${post_id}/pins/pinned_to_room`)
}

export const unpinPostToRoom = async (post_id: string) => {
  return await requestV1<null>(
    'delete',
    `/posts/${post_id}/pins/pinned_to_room`
  )
}
